import { ApprovedExpenseItem } from '@webapp/modules/expense/entities/ApprovedExpenseItem'
import { type IExpenseRepository } from '../../interfaces/IExpenseRepository'

interface GetExpenseItemCorrectionFormDataParams {
  reportId: number
  excludeExpenseItemId: number
}

interface GetExpenseItemCorrectionFormDataResult {
  siblings: ApprovedExpenseItem[]
}

interface Dependency {
  expenseRepository: Pick<IExpenseRepository, 'getReportItems'>
}

/**
 * Hydrates the account-code correction form's sibling rows: fetches the
 * expense report's line items (v1 report fetch), excludes the item being
 * corrected, and recomputes line numbers by index — Angular parity
 * (BHV-016).
 */
export class GetExpenseItemCorrectionFormDataUseCase {
  constructor(private readonly deps: Dependency) {}

  execute = async ({
    reportId,
    excludeExpenseItemId,
  }: GetExpenseItemCorrectionFormDataParams): Promise<GetExpenseItemCorrectionFormDataResult> => {
    const constructors =
      await this.deps.expenseRepository.getReportItems(reportId)

    const siblings = constructors
      .filter((constructor) => constructor.id !== excludeExpenseItemId)
      .map(
        (constructor, index) =>
          new ApprovedExpenseItem({ ...constructor, lineNumber: index + 1 })
      )

    return { siblings }
  }
}
